import axios from 'axios';

const api = axios.create({
  baseURL: process.env.VUE_APP_BACK_URL || 'http://192.168.1.68:3000',
});

export default api;
